import { render, staticRenderFns } from "./bo-cell-product.vue?vue&type=template&id=4f17ca48"
import script from "./bo-cell-product.vue?vue&type=script&lang=js"
export * from "./bo-cell-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports